import React,{useState} from "react";
import { Box, Button } from "@mui/material";
import DynamicTableForJson from "../../../../../data/DynamicTable/dynamicTableForJson";
import { customerservice } from "../../../../../config";
import GroupMembersForm from "./form"; // Adjust this import to match your CustomerGroupView form component
import { useNavigate } from "react-router-dom";
import Joyride from "react-joyride"; // Import Joyride

const base_url = customerservice.uri;
// Define Joyride tour steps
const rightsTourSteps = [
  {
    target: ".dynamic-table-header",
    content: "This is the Group Members Management page, where you can manage a group members.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find a specific member by name or other criteria.",
    placement: "bottom",
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to add a new group member.",
    placement: "right",
  },
  {
    target: ".dynamic-table-actions",
    content: "Select actions like Edit or Deactivate for each member from this dropdown.",
    placement: "left",
  },
];
const ignoreFields =  [
  "RoleId",
  "RoFirstname",
  "RoLastname",
  "GroupMobile",
  "Company",
  "Branch",
  "Region",
  "LoanLimit",
  "GroupName",
  "GroupId",
  "IsActive",
  "RegFeePaid",
  "AccountBalance",
  "CustomerLimit",
  "Email",
  "GroupOlb",
  "Title",
  "GenderName",
  "IdNoOrPassport",
  "DateCreated",
  "CustomerIsActive",
  "CompanyId",
  "RegionId",
  "BranchId",
  "FieldOfficerId",
];
const GroupMembersTable = () => {
  const [runTour, setRunTour] = useState(false); // ▶️ State to control Joyride

  const groupId = localStorage.getItem("GroupId");
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const navigate = useNavigate();

  const actions = {
    entity: "Members",
    isSubright:true,
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: true,
      permission: "ActivatePermission",
      modelName: "customerGroupIds", // Specify the model name here
      inputObjectName: "bulkActivateDeactivateCustomerGroups",
    },
    removeCustomerFromGroup:{
      key: "REMOVECUSTOMERFROMGROUP",
      button_name: "RemoveCustomer",
      Show_Button: true,
      permission: "EditPermission",


    },
    dataObject: {
      ignoreFields: ignoreFields,
      objectName: "customerGroupViewByColumnValues",
      parameters: { groupId: parseInt(groupId) },
      inputObjectName: "customerGroupView",
    },
  };
  
  return (
    <Box m="20px">
        {/* Joyride Component */}
                  <Joyride
                    steps={rightsTourSteps}
                    run={runTour}
                    continuous
                    showSkipButton
                    showProgress
                    styles={{
                      options: {
                        primaryColor: "#1976d2",
                        zIndex: 10000,
                      },
                    }}
                  />

    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
      <Button onClick={ () => navigate(-1)} variant="contained">
            Back to Groups
          </Button>
      <Button onClick={() => setRunTour(true)} variant="outlined" color="primary">
              Start Page Tour
      </Button>
      </Box>
      <>
      </>
      <DynamicTableForJson
        title="Group Members"
        subtitle="Manage Group Members"
        FormComponent={GroupMembersForm}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
};

export default GroupMembersTable;
